import { Button } from '@material-ui/core';
import { useEffect, useState, useMemo } from 'react';
import { CustomToolTip } from '../../../../lib/DataTable';
import en from '../../../../lang/en-us';
import { connect, useDispatch } from 'react-redux';
import { getFundTransactionInfo } from '../../../../redux-store/actions/commercialTransactions';
import LineChart from '../../../../lib/LineChart';
import { getSubcategory } from './explore-mf-filters';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { dateConvert, decimalFix } from '../../portfolios/utils';
import { DEFAULT_CHART_COLORS } from '../../../../lib/PieChar';
import { favLogos, logo } from '../../../../logo/logos';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { SchemeDetailHeaderSkelton } from '../../../../skeltons/NewPurchase';
import { PaymentTypes } from './types';
import { CommercialRootPath } from '../routeConfig';
import RiskMeter from '../../../../lib/RiskMeter';
import { FaqLink } from '../../makeNct';
import { NEW_PURCHASE } from '../../../../utils/constants';
import { SET_IS_FROM_PRE_LOGIN as SET_IS_FROM_PRE_LOGIN } from '../../../../redux-store/types/login';
import { RootStateType } from '../../../../redux-store/reducers';
import { useSelector } from 'react-redux';
import { CLEAR_SIP_OR_LUMPSUM } from '../../../../redux-store/types/newPurchase';

const { dbCommercial, common } = en;

const SEGMENTS = [dbCommercial.exploreMfs.Sip, dbCommercial.exploreMfs.Lumpsum];
const LIST_LIMIT = 8;

function ExploreMFDetails(props: any) {
    const { buttonDisable = false } = props.location.state || {};
    const [statementType, setType] = useState(SEGMENTS[0]);
    const [data, setData] = useState<any>({});
    const { isin } = props.match.params || {};
    const [showAll, setShowAll] = useState<boolean>(false);
    const [logoUrl, setLogoUrl] = useState<any>({ logo: 'default', fav: 'default' });
    const [loading, setLoading] = useState<boolean>(true);
    const dispatch = useDispatch();
    const { isLoggedIn = false } = useSelector((state: RootStateType) => state.authReducer);

    useEffect(() => {
        let key = data.schemeMaster?.fundAmcCode;
        setLogoUrl({ logo: logo[key], fav: favLogos[key] });
    }, [data]);

    const handleSegmentChange = (selectedSegmentIndex: number) => {
        setType(SEGMENTS[selectedSegmentIndex]);
    };

    useEffect(() => {
        async function callApi() {
            try {
                let { body = {} } = await props.getFundTransactionInfo(isin);
                setData(body);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
        return () => {
            dispatch({ type: CLEAR_SIP_OR_LUMPSUM });
        };
    }, []);

    const sortedCompanyList = useMemo(
        () =>
            data?.companies?.sort((a: any, b: any) => b.assetPercentage - a.assetPercentage) || [],
        [data],
    );
    const companyListBySize = useMemo(
        () => (showAll ? sortedCompanyList : sortedCompanyList.slice(0, LIST_LIMIT)),
        [sortedCompanyList, showAll],
    );

    const onStartInvest = (type: PaymentTypes) => (): void => {
        props.history.push(
            `${CommercialRootPath}/${isin}/invest?amc=${data.schemeMaster?.fundAmcCode}`,
            { type, reset: true },
        );

        if (!isLoggedIn) {
            // set isFromPreLogin flag
            dispatch({
                type: SET_IS_FROM_PRE_LOGIN,
                body: true,
            });
        }
    };
    return (
        <div className="portfolio-schemes-page explore-mf-details">
            <div className="db-banner db-portfolio">
                <div>
                    <h3>
                        <AsyncLoader
                            skelton={<SchemeDetailHeaderSkelton />}
                            data={loading ? null : true}
                        >
                            <>
                                <a onClick={() => props.history.goBack()} className="backbtn">
                                    <img src="/images/left-arrow-white.svg" alt="icon" />
                                </a>
                                <div className="list-cards-image">
                                    <img
                                        src={`/images/fav-logos/${logoUrl.fav}.svg`}
                                        alt=""
                                        className="list-logo"
                                    />
                                </div>
                                <div className="explore-mf-details-fund-heading">
                                    <div className="explore-mf-details-fund-name">
                                        {data?.schemeMaster?.schemeName}
                                    </div>
                                    <div className="explore-mf-details-fund-tags">
                                        <p className="tags">
                                            <span>{data?.schemeMaster?.schemeCategory}</span>
                                            <span>
                                                {getSubcategory(
                                                    data?.schemeMaster?.schemeSubCategory,
                                                )}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </>
                        </AsyncLoader>
                    </h3>
                </div>
                <div className="emf-change-plan">
                    {!buttonDisable && (
                        <>
                            <a onClick={onStartInvest(PaymentTypes.SIP)}>
                                <img src="/images/start-sip.svg" alt="icon" />
                                {dbCommercial.exploreMfs.startSip}
                            </a>
                            <a onClick={onStartInvest(PaymentTypes.Lumpsum)}>
                                {dbCommercial.exploreMfs.startLumpsum}
                            </a>
                        </>
                    )}
                    <div className="emf-change-btns-mobile mobile_mode">
                        <div className="btns">
                            <Button
                                className="customBtn"
                                onClick={onStartInvest(PaymentTypes.SIP)}
                                disabled={!data.schemeMaster}
                            >
                                <img src="/images/start-sip.svg" alt="icon" />
                                {dbCommercial.exploreMfs.startSip}
                            </Button>
                            <Button
                                className="customBtn"
                                onClick={onStartInvest(PaymentTypes.Lumpsum)}
                                disabled={!data.schemeMaster}
                            >
                                <img src="/images/start-lumpsum.svg" alt="icon" />
                                {dbCommercial.exploreMfs.startLumpsum}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="portfolio-schemes-page-bottom">
                <div className="returns-outer">
                    {/* <div className="returns">
                        <h4>
                            {dbCommercial.exploreMfs.returns}
                            <b>₹3773.5420</b>
                            <span>( As on 24 May 2021)</span>
                        </h4>
                    </div> */}
                    <div className="returns-info">
                        <div className="returns-graph">
                            <LineChart
                                data={
                                    data?.navData
                                        ?.sort((a: any, b: any) => {
                                            if (a[0] < b[0]) return -1;
                                            if (a[0] > b[0]) return 1;
                                            return 0;
                                        })
                                        ?.map(([time, value]: string[]) => [
                                            Number(time),
                                            Number(value),
                                        ]) || []
                                }
                                loading={loading}
                            />
                        </div>
                        <div className="mf-returns-info">
                            <div className="mf-returns-info-single">
                                <p>{dbCommercial.exploreMfs.aum}</p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>
                                        {formatAsIndianCurrency(
                                            Number(data?.schemeMaster?.aum || 0),
                                        )}
                                        Cr
                                    </h5>
                                </AsyncLoader>
                            </div>
                            <div className="mf-returns-info-single">
                                <p>{dbCommercial.exploreMfs.nav}</p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>
                                        {formatAsIndianCurrency(
                                            Number(data?.schemeMaster?.nav || 0),
                                        )}
                                        <span>
                                            ( {common.asOn}{' '}
                                            {dateConvert(data?.schemeMaster?.navDate)})
                                        </span>
                                    </h5>
                                </AsyncLoader>
                            </div>
                            <div className="mf-returns-info-single">
                                <p style={{ display: 'inline-flex' }}>
                                    {dbCommercial.exploreMfs.exitLoad}
                                    <CustomToolTip
                                        title={data?.schemeMaster?.exitLoadNote || 'NIL'}
                                        arrow
                                    >
                                        <img
                                            src="/images/info1.svg"
                                            alt="icon"
                                            width="15px"
                                            style={{ marginLeft: 5 }}
                                        />
                                    </CustomToolTip>
                                </p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>{data?.schemeMaster?.exitLoad || 'Nil'}</h5>
                                </AsyncLoader>
                            </div>
                            {/* <div className="mf-returns-info-single">
                                <p>{dbCommercial.exploreMfs.minLumpsum}</p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>
                                        {formatAsIndianCurrency(
                                            Number(data?.schemeMaster?.minAmountLumpsum),
                                        )}{' '}
                                        /{' '}
                                        {formatAsIndianCurrency(
                                            Number(data?.schemeMaster?.minAmountSIP),
                                        )}
                                    </h5>
                                </AsyncLoader>
                            </div> */}
                            <div className="mf-returns-info-single">
                                <p>{dbCommercial.exploreMfs.fundType}</p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>{data?.schemeMaster?.fundType || 'NA'}</h5>
                                </AsyncLoader>
                            </div>
                            <div className="mf-returns-info-single">
                                <p>{dbCommercial.exploreMfs.plan}</p>
                                <AsyncLoader data={loading ? null : true}>
                                    <h5>{data?.schemeMaster?.plan || 'NA'}</h5>
                                </AsyncLoader>
                            </div>
                        </div>
                    </div>
                </div>
                {!!data?.schemeMaster && (
                    <div className="mf-returns-bottom">
                        <div className="mf-returns-bottom-inner">
                            <div className="mf-returns-bottom-left">
                                {data?.sectors?.length ? (
                                    <div className="mf-returns-bottom-sections">
                                        <h4>{dbCommercial.exploreMfs.sectors}</h4>
                                        <div className="mf-returns-bottom-sections-info">
                                            <h6>{dbCommercial.exploreMfs.sector}</h6>
                                            <h6>{dbCommercial.exploreMfs.allocation}</h6>
                                        </div>
                                        {data.sectors.map((sector: any, index: number) => (
                                            <div
                                                key={sector.name}
                                                className="mf-returns-bottom-sections-info"
                                            >
                                                <p>{sector.name}</p>
                                                <p>
                                                    <span className="txt">
                                                        {decimalFix(sector.allocation)}%
                                                    </span>{' '}
                                                    <div className="line-bar">
                                                        <span
                                                            style={{
                                                                backgroundColor:
                                                                    DEFAULT_CHART_COLORS[
                                                                        index %
                                                                            DEFAULT_CHART_COLORS.length
                                                                    ],
                                                                width: `${sector.allocation}%`,
                                                            }}
                                                        ></span>
                                                    </div>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                                <div className="mf-returns-bottom-sections">
                                    <h4>{dbCommercial.exploreMfs.companies}</h4>
                                    <div className="mf-returns-bottom-sections-info">
                                        <h6>{dbCommercial.exploreMfs.company}</h6>
                                        <h6>{dbCommercial.exploreMfs.allocation}</h6>
                                    </div>
                                    {companyListBySize.map((company: any, index: number) => (
                                        <div
                                            key={company.companyFullName + `${index}`}
                                            className="mf-returns-bottom-sections-info"
                                        >
                                            <p>{company.companyFullName}</p>
                                            <p>
                                                <span className="txt">
                                                    {decimalFix(company.assetPercentage)}%
                                                </span>
                                                <div className="line-bar">
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                DEFAULT_CHART_COLORS[
                                                                    index %
                                                                        DEFAULT_CHART_COLORS.length
                                                                ],
                                                            width: `${company.assetPercentage}%`,
                                                        }}
                                                    ></span>
                                                </div>
                                            </p>
                                        </div>
                                    ))}
                                    {/* <div className="mf-returns-bottom-sections-info">
                            <p>HDFC Flexi Cap Fund - Direct Plan- Growth Option </p>
                            <p>
                                <span className="txt">15.76%</span>
                                <div className="line-bar">
                                    <span
                                        style={{
                                            backgroundColor: 'rgb(15, 196, 145)',
                                            width: '80%',
                                        }}
                                    ></span>
                                </div>
                            </p>
                        </div>
                        <div className="mf-returns-bottom-sections-info">
                            <p>HDFC Short Term Debt Fund - Growth Option - Direct Plan </p>
                            <p>
                                <span className="txt">9.54%</span>
                                <div className="line-bar">
                                    <span
                                        style={{
                                            backgroundColor: 'rgb(95, 71, 153)',
                                            width: '35%',
                                        }}
                                    ></span>
                                </div>
                            </p>
                        </div>
                        <div className="mf-returns-bottom-sections-info">
                            <p>HDFC Flexi Cap Fund - Direct Plan- Growth Option </p>
                            <p>
                                <span className="txt">31.76%</span>
                                <div className="line-bar">
                                    <span
                                        style={{
                                            backgroundColor: 'rgb(15, 196, 145)',
                                            width: '60%',
                                        }}
                                    ></span>
                                </div>
                            </p>
                        </div> */}
                                    {sortedCompanyList > LIST_LIMIT && (
                                        <a onClick={() => setShowAll((prev) => !prev)}>
                                            {showAll
                                                ? dbCommercial.exploreMfs.showLess
                                                : dbCommercial.exploreMfs.showAll}
                                            <img
                                                src={`/images/${
                                                    showAll
                                                        ? 'up-arrow-purple.svg'
                                                        : 'down-arrow-purple.svg'
                                                }`}
                                                alt="arrow"
                                            />
                                        </a>
                                    )}
                                    {/* <a>
                            {dbCommercial.exploreMfs.showLess}
                            <img src="/images/up-arrow-purple.svg" alt="icon" />
                        </a> */}
                                </div>
                            </div>
                            <div className="mf-returns-bottom-right">
                                <RiskMeter height={180} risk={data?.schemeMaster?.colour} />
                                <div className="fund-manager">
                                    <div className="fund-manager-logo">
                                        <img
                                            src={`/images/client-logos/${logoUrl.logo}.png`}
                                            alt=""
                                        />
                                    </div>
                                    <div className="fund-manager-txt">
                                        <p>{dbCommercial.exploreMfs.fundManager}</p>
                                        <AsyncLoader data={loading ? null : true}>
                                            <h5>{data?.schemeMaster?.fundManager}</h5>
                                        </AsyncLoader>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                marginTop: 15,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            <FaqLink section={NEW_PURCHASE} />
                            <p className="source-footer" style={{ margin: 0, marginBottom: 5 }}>
                                <img src="/images/source-icon.svg" alt="icon" />
                                <span> {dbCommercial.newPurchase.vrFooterSource}</span>
                                {dbCommercial.newPurchase.vrFooterInfo}
                            </p>
                        </div>
                    </div>
                )}
                {/* <div className="return-calculator">
                    <h4>{dbCommercial.exploreMfs.returnCalculator}</h4>
                    <div className="return-cal-content">
                        <div className="return-cal-slider">
                            <SegmentedControl
                                segments={SEGMENTS}
                                onSegmentChanged={handleSegmentChange}
                                selectedSegmentIndex={SEGMENTS.findIndex(
                                    (str: string) => str === statementType,
                                )}
                                key={statementType}
                            />
                            {statementType === SEGMENTS[0] ? (
                                <div className="return-slider-content">
                                    <CommercialSlider
                                        min={50}
                                        aria-label="sip-slider"
                                        // valueLabelDisplay="auto"
                                    />
                                    <div className="slider-bottom">
                                        <p>
                                            <span>₹7,000 </span> per month
                                        </p>
                                        <h6>₹50K</h6>
                                    </div>
                                    <div className="over-the-past">
                                        <p>{dbCommercial.exploreMfs.overThePast}</p>
                                        <div className="years-tags">
                                            <a className="active">1 Year</a>
                                            <a>3 Years</a>
                                            <a>5 Years</a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="return-slider-content">
                                    <CommercialSlider
                                        min={30}
                                        aria-label="lumpsum-slider"
                                        // valueLabelDisplay="auto"
                                    />
                                    <div className="slider-bottom">
                                        <p>
                                            <span>₹5,000 </span> per month
                                        </p>
                                        <h6>₹100K</h6>
                                    </div>
                                    <div className="over-the-past">
                                        <p>{dbCommercial.exploreMfs.overThePast}</p>
                                        <div className="years-tags">
                                            <a className="active">1 Year</a>
                                            <a>3 Years</a>
                                            <a>5 Years</a>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="return-cal-investment">
                            <img
                                src="/images/return-calc-img.png"
                                alt="icon"
                                className="return-calc-img"
                            />
                            <div className="return-inv-txt">
                                <p>{dbCommercial.exploreMfs.totalInvestment}</p>
                                <h5>₹84,000</h5>
                            </div>
                            <div className="return-inv-txt funds-return">
                                <p>{dbCommercial.exploreMfs.fundsReturn}</p>
                                <h5>
                                    ₹97,335
                                    <span>(+8.34%)</span>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="return-calc-disclaimers">
                    <img src="/images/error-red.svg" alt="icon" />
                    {dbCommercial.exploreMfs.returnCalcDisclaim}
                </p> */}
            </div>
        </div>
    );
}
export default connect(null, { getFundTransactionInfo })(ExploreMFDetails);
